import { useConfig } from '../../providers/config'

/**
 * @description Returns the storelocator store urlKey.
 * If the custom urlKey isn't passed, returns the default urlKey.
 * @param {string} storeId - ID of the store
 * @param {string} urlKey - Url key of the store
 * @returns {string} urlKey
 */
export const useStoreLocatorUrl = (storeId, urlKey = '') => {
	const {
		storelocator: { storeDetailsPath },
	} = useConfig()

	return urlKey ? urlKey : storeDetailsPath + storeId
}
